import BaseStore from 'stores/BaseStore'

class ValidatorStore extends BaseStore {
  constructor() {
    super('validators', 'validators', { site_model: true })
  }
}

export default new ValidatorStore()
